<template>
  <div>
    <el-page-header content="答卷详情" class="dw-page-header" @back="goBack"></el-page-header>
    <div class="dw-answer-content">
      <el-row type="flex" class="row-bg">
        <el-col :span="16" :push="4">
          <div style="background: white;">
            <el-descriptions :column="3" border>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-location-information"></i> 答卷IP
                </template>
                {{ survey.surveyAnswer.ipAddr }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-timer"></i>
                  答卷时间
                </template>
                {{ survey.surveyAnswer.endAnDate }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-monitor"></i>
                  答题数
                </template>
                {{ survey.surveyAnswer.completeItemNum }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-price-tag"></i> 答卷ID
                </template>
                {{ survey.surveyAnswer.id }}
              </el-descriptions-item>
            </el-descriptions>
            <div class="dw-answer-title" style="padding-top: 30px;padding-bottom: 0px;">答卷结果信息</div>
            <div style="padding: 0px 20px 30px 20px;">
              <dw-survey-answer-qu-common v-for="(item, index) in survey.questions" :key="item.id" :id="item.id" :index="index" :question="item"></dw-survey-answer-qu-common>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>

import DwSurveyDcsWrapper from '@/components/common/DwSurveyDcsWrapper'
import DwSurveyAnswerQuCommon from './DwSurveyAnswerQuCommon'
import { dwSurveyAnswerInfo } from '@/api/dw-survey'

export default {
  name: 'DwSurveyAnswerInfo',
  components: {
    DwSurveyDcsWrapper,
    DwSurveyAnswerQuCommon
  },
  data() {
    return {
      survey: {
        questions: []
      },
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      radio: 3,
      formSize: 'medium',
      rateValue: 3.7,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: ''
    }
  },
  mounted() {
    this.querySurveyAnswer(1)
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    handleInfo(index, row) {
      console.log(index, row)
    },
    handleDelete(index, row) {
      console.log(index, row)
    },
    querySurveyAnswer() {
      dwSurveyAnswerInfo(this.$route.params.answerId).then((response) => {
        const resultData = response.data.data
        // const resultData = {
        //   "id": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //   "sid": "tt1uwj",
        //   "parentId": "",
        //   "surveyName": "<p><span style=\"font-size: 24px;\"><strong>2025届毕业生岗位实习调查问卷</strong></span><span style=\"font-size: 20px;\"></span><span style=\"font-size: 18px;\"></span></p>",
        //   "surveyNameText": "2025届毕业生岗位实习调查问卷",
        //   "userId": "100514043",
        //   "userName": null,
        //   "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //   "depId": null,
        //   "depName": null,
        //   "dirType": 2,
        //   "surveyDetailId": null,
        //   "createDate": "2024-10-22 16:38:13",
        //   "surveyState": 1,
        //   "surveyQuNum": 26,
        //   "anItemLeastNum": 0,
        //   "answerNum": 414,
        //   "visibility": 1,
        //   "surveyModel": 1,
        //   "viewAnswer": 0,
        //   "isShare": 0,
        //   "excerptNum": 0,
        //   "surveyTag": 1,
        //   "htmlPath": null,
        //   "jsonPath": "671770cb87def40001dbbef5",
        //   "isTemplate": 0,
        //   "groupName": null,
        //   "surveyDetail": {
        //     "id": "e32e626e-3d68-470d-9dca-877bb95fac32",
        //     "dirId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "effective": 0,
        //     "effectiveTime": 5,
        //     "effectiveIp": 1,
        //     "refresh": 0,
        //     "refreshNum": 3,
        //     "rule": 0,
        //     "ruleCode": "令牌",
        //     "endType": 1,
        //     "endTime": null,
        //     "endNum": 1000,
        //     "surveyNote": "非常感谢您的参与！如有涉及个人信息，我们将严格保密。",
        //     "ynEndNum": 0,
        //     "ynEndTime": 0,
        //     "surveyQuNum": 0,
        //     "anItemLeastNum": 0,
        //     "anItemMostNum": 0,
        //     "mailOnly": 0,
        //     "showShareSurvey": 0,
        //     "showAnswerDa": 0
        //   },
        //   "questions": [
        //     {
        //       "id": "97e72779-d5d8-4da0-be76-f402f624f2a2",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你是否了解实习的意义、目的、规划以及注意事项</font><font face=\"仿宋_GB2312\">?</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 1,
        //       "createDate": "2024-10-22 16:38:51",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "4e86bcf4-00a5-4710-9b90-a01ed930e1e8",
        //           "quId": "97e72779-d5d8-4da0-be76-f402f624f2a2",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><font face=\"仿宋_GB2312\"><span style=\"font-size: 21.3333px;\">了解</span></font></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "5eee2bff-3b20-4375-a445-214abb32355a",
        //           "quId": "97e72779-d5d8-4da0-be76-f402f624f2a2",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">不了解</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "ec384892-8968-4419-8a46-ba31ec0254ef",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "97e72779-d5d8-4da0-be76-f402f624f2a2",
        //         "quItemId": "4e86bcf4-00a5-4710-9b90-a01ed930e1e8",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "33129d87-cb88-4510-8bdc-7f0cb27e6649",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你对实习期间有什么期待</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 2,
        //       "createDate": "2024-10-22 16:40:16",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "ff1eb1ce-9519-4aa4-8e71-d229da7bf2f9",
        //           "quId": "33129d87-cb88-4510-8bdc-7f0cb27e6649",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">专业技能得到提高</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "e8137657-accf-41b0-a8d6-549846f67b90",
        //           "quId": "33129d87-cb88-4510-8bdc-7f0cb27e6649",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">为毕业后的工作积累工作经验</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "7579b777-832d-4e88-9257-3263bbf1d2bc",
        //           "quId": "33129d87-cb88-4510-8bdc-7f0cb27e6649",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">没有期待，学习为重，主要备考升本</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "6c1ef7ce-fb0b-4c73-9624-3cc6675f8b0e",
        //           "quId": "33129d87-cb88-4510-8bdc-7f0cb27e6649",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">其他（请注明）</span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "62eed746-8dfe-4f00-ab00-6181cf767a68",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "33129d87-cb88-4510-8bdc-7f0cb27e6649",
        //         "quItemId": "e8137657-accf-41b0-a8d6-549846f67b90",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "48cea967-9bd5-4c03-ae19-67aef6973721",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你对实习工作的强烈要求是什么</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 3,
        //       "createDate": "2024-10-22 16:51:25",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "89821ca3-7960-4b1c-8036-8cf2ea5a2be8",
        //           "quId": "48cea967-9bd5-4c03-ae19-67aef6973721",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">工资多少无所谓，但双休且节假日正常放假</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "ae23c89a-95fc-4732-a666-b308fd59d31d",
        //           "quId": "48cea967-9bd5-4c03-ae19-67aef6973721",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">工资高</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "b07f3cf1-fd44-4806-a7f4-cef3eb04eb3a",
        //           "quId": "48cea967-9bd5-4c03-ae19-67aef6973721",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">以学习技能、积累经验为最主要</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "b91b010d-6fef-40fc-80f6-1f66dda47667",
        //           "quId": "48cea967-9bd5-4c03-ae19-67aef6973721",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">其他（请注明）</span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "d1bdb168-b330-4065-b9b1-a22e27f9d9ef",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "48cea967-9bd5-4c03-ae19-67aef6973721",
        //         "quItemId": "89821ca3-7960-4b1c-8036-8cf2ea5a2be8",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "d96341fe-e308-45fd-afaf-a2d60bfbf6cd",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你对实习的行业领域有特定的偏好吗</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 4,
        //       "createDate": "2024-10-22 16:52:51",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "b0edcb9f-5774-433a-bd88-86db1d1f8fff",
        //           "quId": "d96341fe-e308-45fd-afaf-a2d60bfbf6cd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">专业对口</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "dbe99eee-7b82-419c-8dcb-0eead988b105",
        //           "quId": "d96341fe-e308-45fd-afaf-a2d60bfbf6cd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">专业相近</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "e620eada-6880-49c8-a01f-b66eced01a34",
        //           "quId": "d96341fe-e308-45fd-afaf-a2d60bfbf6cd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">自己喜欢的工作不对口也可以</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "5fb486d9-9701-4a9a-97a3-8c968384d478",
        //           "quId": "d96341fe-e308-45fd-afaf-a2d60bfbf6cd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">其他（请注明）</span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "fae8db16-b130-42ab-9345-fa0276057630",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "d96341fe-e308-45fd-afaf-a2d60bfbf6cd",
        //         "quItemId": "e620eada-6880-49c8-a01f-b66eced01a34",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "2650683d-2279-4b52-817e-b097393a7dbd",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你希望在实习中获得的主要技能是什么</font><font face=\"仿宋_GB2312\">?（最多选择三项）</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "CHECKBOX",
        //       "tag": 2,
        //       "orderById": 5,
        //       "createDate": "2024-10-22 16:56:56",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 3,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "1",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [],
        //       "quCheckboxs": [
        //         {
        //           "id": "6d28d75d-b0f5-4113-be94-002334ed3242",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">专业知识的应用能力</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "153f728b-c695-4a4e-bb31-0921271b090e",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">团队合作与沟通能力</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "0f3e0226-2a44-43f9-b0f6-86eed739ddeb",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">解决问题的能力</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "b16bf579-4cfc-4762-b84c-774e4ff2d3ba",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">创新与创造力</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "44ef481c-7be1-443f-b740-b7fdc540732d",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">领导能力</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 4,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "6465ca45-868c-4e17-a076-b485f3c00f77",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">项目管理能力</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 5,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "f09daeb6-9b61-44b4-ae5f-65e15bd94538",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">其他（请注明）</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 6,
        //           "visibility": 1,
        //           "anCount": null
        //         }
        //       ],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [
        //         {
        //           "id": "46cbfad7-63a1-4ba4-a432-759f7eea7569",
        //           "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //           "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "quItemId": "6d28d75d-b0f5-4113-be94-002334ed3242",
        //           "otherText": null,
        //           "visibility": 1
        //         },
        //         {
        //           "id": "9da21888-82b6-402f-b81e-6d63b56c9ac7",
        //           "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //           "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "quItemId": "0f3e0226-2a44-43f9-b0f6-86eed739ddeb",
        //           "otherText": null,
        //           "visibility": 1
        //         },
        //         {
        //           "id": "ce59bb01-c556-424d-b9f7-13b28a8859a8",
        //           "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //           "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //           "quId": "2650683d-2279-4b52-817e-b097393a7dbd",
        //           "quItemId": "153f728b-c695-4a4e-bb31-0921271b090e",
        //           "otherText": null,
        //           "visibility": 1
        //         }
        //       ],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "quItemId": null,
        //         "otherText": null,
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "ac63b9aa-d5e7-4260-96d2-92288942b8fe",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你对实习的工作地点要求是什么</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 6,
        //       "createDate": "2024-10-22 16:59:46",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "7307d4db-9f92-42b9-b14c-78781249cf94",
        //           "quId": "ac63b9aa-d5e7-4260-96d2-92288942b8fe",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">在家当地</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "e6f95bd4-caaf-4c66-b02e-9ce716dd439e",
        //           "quId": "ac63b9aa-d5e7-4260-96d2-92288942b8fe",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">山东省内或者淄博市周边城市都可以</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "7d27a772-c2c6-4865-a5dd-4838767e054a",
        //           "quId": "ac63b9aa-d5e7-4260-96d2-92288942b8fe",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">省外距离远也没关系（需提供住宿）</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "6cc87a06-da72-4410-8c0c-6e50d26a92d7",
        //           "quId": "ac63b9aa-d5e7-4260-96d2-92288942b8fe",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">已有目标城市（请注明）</span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "bd2912cd-e0e6-4916-b53c-c11a31396d15",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "ac63b9aa-d5e7-4260-96d2-92288942b8fe",
        //         "quItemId": "7307d4db-9f92-42b9-b14c-78781249cf94",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "1c31ba96-7f0b-418b-8ad0-9e8da4da5228",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">实习期间你是否愿意自己承担住宿等费用</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 7,
        //       "createDate": "2024-10-22 17:01:48",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "eb4749ea-0e7d-4176-9f38-1305b8c278fc",
        //           "quId": "1c31ba96-7f0b-418b-8ad0-9e8da4da5228",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">完全愿意</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "78e2b05e-304c-4575-8dfe-225321380844",
        //           "quId": "1c31ba96-7f0b-418b-8ad0-9e8da4da5228",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">愿意承担部分费用</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "71d3b5b3-d806-42b7-9384-77ba984eefc0",
        //           "quId": "1c31ba96-7f0b-418b-8ad0-9e8da4da5228",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">希望公司能够承担</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "34e37cc6-6d3e-4cc9-94a3-76b87f2e44de",
        //           "quId": "1c31ba96-7f0b-418b-8ad0-9e8da4da5228",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">不愿意承担任何费用</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "92885cf5-63ad-4872-8b30-77676f8ec5e0",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "1c31ba96-7f0b-418b-8ad0-9e8da4da5228",
        //         "quItemId": "71d3b5b3-d806-42b7-9384-77ba984eefc0",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "665b2abd-f938-429a-8b54-c74e1d11d6e8",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你对实习的薪资要求是什么</font><font face=\"仿宋_GB2312\">?</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 8,
        //       "createDate": "2024-10-22 17:02:07",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "632cafa1-8261-42ef-a929-d98296aca8cb",
        //           "quId": "665b2abd-f938-429a-8b54-c74e1d11d6e8",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">实习津贴（每月</font><font face=\"仿宋_GB2312\">2000元以下）</font></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "cc18cfc0-9d36-49cb-9319-a97e6702a796",
        //           "quId": "665b2abd-f938-429a-8b54-c74e1d11d6e8",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">实习津贴（每月</font><font face=\"仿宋_GB2312\">2000-3000元）</font></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "a95ff2a4-8ebf-430e-86a4-a2fcdb86617a",
        //           "quId": "665b2abd-f938-429a-8b54-c74e1d11d6e8",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">实习津贴（每月</font><font face=\"仿宋_GB2312\">3000-4000元）</font></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "1498b2dd-96d1-4bb0-9433-51d04cceaee2",
        //           "quId": "665b2abd-f938-429a-8b54-c74e1d11d6e8",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">实习津贴（每月</font><font face=\"仿宋_GB2312\">4000元以上）</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "193695b5-35d7-413a-8a93-ec269621c517",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "665b2abd-f938-429a-8b54-c74e1d11d6e8",
        //         "quItemId": "1498b2dd-96d1-4bb0-9433-51d04cceaee2",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "34d544c7-93b3-439b-9493-3da6bb09f477",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">在了解学校推荐的实习单位中，是否有意向前往</font><font face=\"仿宋_GB2312\">?</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 9,
        //       "createDate": "2024-10-22 17:04:46",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "5f5b0f95-86d8-416e-b87c-d1118dfb4822",
        //           "quId": "34d544c7-93b3-439b-9493-3da6bb09f477",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">是</span><span style=\"font-family: 仿宋_GB2312; font-size: 16pt;\">（企业名称）</span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "5daf8a47-7ae9-46a0-a21d-dde992f19ed1",
        //           "quId": "34d544c7-93b3-439b-9493-3da6bb09f477",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">否</span><span style=\"font-family: 仿宋_GB2312; font-size: 16pt;\">(请注明原因）</span></p><p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "bc657df4-22b7-43ec-abe8-c50586d5b948",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "34d544c7-93b3-439b-9493-3da6bb09f477",
        //         "quItemId": "5daf8a47-7ae9-46a0-a21d-dde992f19ed1",
        //         "otherText": "无",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "61e1f219-fc44-4a00-bfaf-17799795597e",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">你的意向单位的规模是？</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 10,
        //       "createDate": "2024-10-22 17:05:41",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "d167edfb-2faf-48f4-a8d9-4ff46ef3dbec",
        //           "quId": "61e1f219-fc44-4a00-bfaf-17799795597e",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">大型（</font><font face=\"仿宋_GB2312\">10000人以上）</font></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "868db66f-23c3-4100-982c-9e8053b33751",
        //           "quId": "61e1f219-fc44-4a00-bfaf-17799795597e",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">中型（</font><font face=\"仿宋_GB2312\">500-9999人）</font></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "0d3c7001-5251-4e0f-8104-3044d43960df",
        //           "quId": "61e1f219-fc44-4a00-bfaf-17799795597e",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">小型（</font><font face=\"仿宋_GB2312\">20-499人）</font></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "e3f5c67b-1483-404a-a1d1-f2d425029f0e",
        //           "quId": "61e1f219-fc44-4a00-bfaf-17799795597e",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">微型（</font><font face=\"仿宋_GB2312\">20人以内）</font></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "17dc9dd0-03dd-4975-bf32-1e483d09347a",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "61e1f219-fc44-4a00-bfaf-17799795597e",
        //         "quItemId": "d167edfb-2faf-48f4-a8d9-4ff46ef3dbec",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "3c6b750c-8b5e-49ee-a706-e42fec214041",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你对实习期间的工作环境有什么要求</font><font face=\"仿宋_GB2312\">?（最多选择两项）</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "CHECKBOX",
        //       "tag": 2,
        //       "orderById": 11,
        //       "createDate": "2024-10-22 17:06:56",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 2,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "1",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [],
        //       "quCheckboxs": [
        //         {
        //           "id": "487f9e42-bbcb-495a-8f97-7705d76c8ac2",
        //           "quId": "3c6b750c-8b5e-49ee-a706-e42fec214041",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">舒适的办公环境</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "a538a5d2-ab93-4c0e-af99-d151729e4c56",
        //           "quId": "3c6b750c-8b5e-49ee-a706-e42fec214041",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">良好的工作氛围</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "8eda81d9-4e96-4835-87f3-de35e23681b7",
        //           "quId": "3c6b750c-8b5e-49ee-a706-e42fec214041",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">良好的福利待遇</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "0747d321-1903-4c6c-8b1e-7252f96aa624",
        //           "quId": "3c6b750c-8b5e-49ee-a706-e42fec214041",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">有发展空间的职位</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "db6e5c74-3b2d-48a8-89a5-764de53ca3f4",
        //           "quId": "3c6b750c-8b5e-49ee-a706-e42fec214041",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">其他（请注明）</span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 4,
        //           "visibility": 1,
        //           "anCount": null
        //         }
        //       ],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [
        //         {
        //           "id": "20e0a917-1da2-46a8-a8ac-7c09c89ee1cc",
        //           "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //           "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //           "quId": "3c6b750c-8b5e-49ee-a706-e42fec214041",
        //           "quItemId": "487f9e42-bbcb-495a-8f97-7705d76c8ac2",
        //           "otherText": null,
        //           "visibility": 1
        //         },
        //         {
        //           "id": "77751e36-ff1e-48e5-839c-59f8efc3852b",
        //           "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //           "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //           "quId": "3c6b750c-8b5e-49ee-a706-e42fec214041",
        //           "quItemId": "8eda81d9-4e96-4835-87f3-de35e23681b7",
        //           "otherText": null,
        //           "visibility": 1
        //         }
        //       ],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "quItemId": null,
        //         "otherText": null,
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你在选择实习岗位时最看重的因素是什么</font><font face=\"仿宋_GB2312\">?（最多选择两项）</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "CHECKBOX",
        //       "tag": 2,
        //       "orderById": 12,
        //       "createDate": "2024-10-22 17:20:37",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 2,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "1",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [],
        //       "quCheckboxs": [
        //         {
        //           "id": "a255d72c-27e2-45ff-b838-a6479511c6e5",
        //           "quId": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">公司声誉与知名度</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "38a7af51-c9e9-436c-8f17-042241145543",
        //           "quId": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">实习岗位的专业性</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "86f78a7b-3ca4-4dc9-918a-d07b37c7bdad",
        //           "quId": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">实习岗位的发展潜力</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "c9b32741-8702-42d8-ba1f-234e1338c336",
        //           "quId": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">实习岗位的薪资待遇</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "046a4477-90c7-43fa-89e5-034c954b22ea",
        //           "quId": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">实习岗位的工作环境</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 4,
        //           "visibility": 1,
        //           "anCount": null
        //         },
        //         {
        //           "id": "1e48ae28-02e7-422a-8a95-dbfa22c3c3c3",
        //           "quId": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">其他（请注明）</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 5,
        //           "visibility": 1,
        //           "anCount": null
        //         }
        //       ],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [
        //         {
        //           "id": "7c18cabb-096b-42ac-bd83-4de8b939ffab",
        //           "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //           "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //           "quId": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //           "quItemId": "a255d72c-27e2-45ff-b838-a6479511c6e5",
        //           "otherText": null,
        //           "visibility": 1
        //         },
        //         {
        //           "id": "87fc681f-de05-4df9-9e16-b0d302602d77",
        //           "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //           "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //           "quId": "1c2f3288-6d9a-4a57-ae62-6a8673c3aec9",
        //           "quItemId": "38a7af51-c9e9-436c-8f17-042241145543",
        //           "otherText": null,
        //           "visibility": 1
        //         }
        //       ],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "quItemId": null,
        //         "otherText": null,
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "caf56c25-1733-4cca-b7ac-b8a69f204f9e",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你对实习期的工作更看重获得什么收获</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 13,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "940f38d1-4611-4784-a4b0-e46f817047f1",
        //           "quId": "caf56c25-1733-4cca-b7ac-b8a69f204f9e",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">个人发展得到提高</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "5aa5f120-fc96-4cae-82c5-78502cfa4f64",
        //           "quId": "caf56c25-1733-4cca-b7ac-b8a69f204f9e",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">薪资待遇得到涨幅</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "0c6f36eb-ac1f-4bb8-8a28-36afbbc7bcec",
        //           "quId": "caf56c25-1733-4cca-b7ac-b8a69f204f9e",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">公司对自己实习工作的认可</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "4a856dec-3e85-4cd4-9051-8760d557b084",
        //           "quId": "caf56c25-1733-4cca-b7ac-b8a69f204f9e",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">其他（请注明）</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "26c57ed2-1a69-49d4-ab16-e9f4ad5204f9",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "caf56c25-1733-4cca-b7ac-b8a69f204f9e",
        //         "quItemId": "5aa5f120-fc96-4cae-82c5-78502cfa4f64",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "186a2625-0929-4fcb-a604-349d35c8fa10",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你是否了解你心仪的职业岗位目前的发展状况和岗位要求</font><font face=\"仿宋_GB2312\">?</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 14,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "209969dc-2351-4ed0-b6a3-44bd93fd6824",
        //           "quId": "186a2625-0929-4fcb-a604-349d35c8fa10",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">是</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "5eb1b069-51b5-4daf-9603-e5e69e7cafaa",
        //           "quId": "186a2625-0929-4fcb-a604-349d35c8fa10",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">否</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "7d4d34c8-ef28-4625-a3a5-0a4ed612f114",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "186a2625-0929-4fcb-a604-349d35c8fa10",
        //         "quItemId": "209969dc-2351-4ed0-b6a3-44bd93fd6824",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "1d80288d-fa92-428e-9954-3a778d2ceac3",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你心仪的职业岗位是否有与自身的客观条件结合考虑</font><font face=\"仿宋_GB2312\">?（如自身性格、能力等）</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 15,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "83084f5b-b300-408d-99ec-0cb996854aa7",
        //           "quId": "1d80288d-fa92-428e-9954-3a778d2ceac3",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">是</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "9c85135a-3ecd-425d-a4c7-4931e0be39c1",
        //           "quId": "1d80288d-fa92-428e-9954-3a778d2ceac3",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">否，主要是喜欢</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "c46e0d46-98f5-43cd-8c50-0cd544ad3182",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "1d80288d-fa92-428e-9954-3a778d2ceac3",
        //         "quItemId": "83084f5b-b300-408d-99ec-0cb996854aa7",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "2bb20f1e-5ee8-4b80-9adb-89d5eab1214c",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你觉得目前你所掌握的能力与技能是否与心仪岗位匹配</font><font face=\"仿宋_GB2312\">?</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 16,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "901e2736-6e0c-4c87-a598-b120af7c77cb",
        //           "quId": "2bb20f1e-5ee8-4b80-9adb-89d5eab1214c",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">是</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "97143714-99c5-46fb-8635-980da3258728",
        //           "quId": "2bb20f1e-5ee8-4b80-9adb-89d5eab1214c",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">否</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "71d20bb5-97eb-468e-ae6e-fbf5924569cc",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "2bb20f1e-5ee8-4b80-9adb-89d5eab1214c",
        //         "quItemId": "901e2736-6e0c-4c87-a598-b120af7c77cb",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "b6bac9bf-04bc-418a-85d9-c55ac4d10f19",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你现在是否还对实习还有困惑或迷茫</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 17,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "ccdc2569-56c2-4eb8-88f4-f8832fcbd54c",
        //           "quId": "b6bac9bf-04bc-418a-85d9-c55ac4d10f19",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">是</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "20b0880d-96a7-4570-b2ea-6a2c4a48ff5e",
        //           "quId": "b6bac9bf-04bc-418a-85d9-c55ac4d10f19",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">否</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "a2a76e90-6084-4714-88a5-cbe2da1e9597",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "b6bac9bf-04bc-418a-85d9-c55ac4d10f19",
        //         "quItemId": "ccdc2569-56c2-4eb8-88f4-f8832fcbd54c",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "b0609c53-5aa6-4ef8-a3e5-057d7748f0af",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">在寻找实习单位中最困扰你的是什么</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 18,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "b7db8d2c-4f4e-4169-a3aa-e00b77fc4b43",
        //           "quId": "b0609c53-5aa6-4ef8-a3e5-057d7748f0af",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">学校实习指导不够</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "21d68c10-0633-4fb0-b79b-1465d8b1c1ad",
        //           "quId": "b0609c53-5aa6-4ef8-a3e5-057d7748f0af",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">信息量少</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "bf03b423-5f6a-480d-85d1-15b8a006541c",
        //           "quId": "b0609c53-5aa6-4ef8-a3e5-057d7748f0af",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">对企业岗位专业知识缺乏了解</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "f8ab4048-c5e1-4b1c-8c48-5639a69df860",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "b0609c53-5aa6-4ef8-a3e5-057d7748f0af",
        //         "quItemId": "b7db8d2c-4f4e-4169-a3aa-e00b77fc4b43",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "29152eda-9fab-4712-9774-d547e84e6d51",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">如果你有过实习经历，你最不满意的实习经历是哪一次？</span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 19,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "a5a4eeb2-620e-424b-bdfe-648c978b9614",
        //           "quId": "29152eda-9fab-4712-9774-d547e84e6d51",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">公司规模较小，实习内容单一</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "35d566e1-855e-4680-9851-c987e1803883",
        //           "quId": "29152eda-9fab-4712-9774-d547e84e6d51",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">公司管理混乱，实习体验不佳</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "d63ff386-b7a5-4e44-9557-e957672f83bd",
        //           "quId": "29152eda-9fab-4712-9774-d547e84e6d51",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">公司培训和指导不到位，无法成长</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "1bf71a3a-ebfc-43a9-847a-951ba3a094c4",
        //           "quId": "29152eda-9fab-4712-9774-d547e84e6d51",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">公司给予的薪资和福利较低</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "650a5317-9313-4547-a4a0-f5a7ff94f17d",
        //           "quId": "29152eda-9fab-4712-9774-d547e84e6d51",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">其他（请注明）</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 4,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "13d3b1ed-2154-4641-8ec8-0d00ce639598",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "29152eda-9fab-4712-9774-d547e84e6d51",
        //         "quItemId": "d63ff386-b7a5-4e44-9557-e957672f83bd",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "0f711632-43db-417e-85d9-217eefd01645",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"font-family: 仿宋_GB2312; font-size: 21.3333px;\">你</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">希望通过哪种方式实习？</span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 20,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "45d431b7-1052-4712-989d-97b550db5720",
        //           "quId": "0f711632-43db-417e-85d9-217eefd01645",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">学校推的校企合作企业</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "f9971909-5d47-443f-8bab-040b07ea961e",
        //           "quId": "0f711632-43db-417e-85d9-217eefd01645",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">自主实习</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "3944a232-1a0c-4233-835c-cc1b6aabed65",
        //           "quId": "0f711632-43db-417e-85d9-217eefd01645",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">父母安排</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "4b328891-680a-4ce3-b94f-ee734f29aeb8",
        //           "quId": "0f711632-43db-417e-85d9-217eefd01645",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">亲戚朋友推荐</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "120d3784-7abc-49e4-8b32-bcd343aef6a7",
        //           "quId": "0f711632-43db-417e-85d9-217eefd01645",
        //           "optionTitle": null,
        //           "optionName": "<span style=\"font-family: 仿宋_GB2312; font-size: 21.3333px;\">其他（请注明）</span>",
        //           "isNote": 1,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 4,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "8083b8fa-6f88-42b1-8aea-de0026812c71",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "0f711632-43db-417e-85d9-217eefd01645",
        //         "quItemId": "45d431b7-1052-4712-989d-97b550db5720",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "bd5a9165-e637-4a85-a14a-41a011968780",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">你认为自己目前最欠缺的素质主要是</span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 21,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "5574a175-8d40-4ae1-afc8-b24a9136292a",
        //           "quId": "bd5a9165-e637-4a85-a14a-41a011968780",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">基本的解决问题能力</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "af3642a7-fa9e-4040-9ba2-302246110607",
        //           "quId": "bd5a9165-e637-4a85-a14a-41a011968780",
        //           "optionTitle": null,
        //           "optionName": "<span style=\"font-family: 仿宋_GB2312; font-size: 16pt;\">承受压力、克服困难的压力</span><p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "8cc31797-50ed-4ea9-bbeb-64e7307961cd",
        //           "quId": "bd5a9165-e637-4a85-a14a-41a011968780",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">专业这知识和技能</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "f5e8c6c0-f372-4b82-a8b1-08544fb173e3",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "bd5a9165-e637-4a85-a14a-41a011968780",
        //         "quItemId": "af3642a7-fa9e-4040-9ba2-302246110607",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "981d95a5-554c-49a4-b61a-1f509ddbd3a7",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">在寻找实习单位中最困扰你的是什么</font><font face=\"仿宋_GB2312\">?</font></span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 22,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "e47ad40b-6772-40cb-b677-4a0a3528a595",
        //           "quId": "981d95a5-554c-49a4-b61a-1f509ddbd3a7",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">学校实习指导不够</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "dff5a5dd-9fc5-47f0-8fda-2b75c341a891",
        //           "quId": "981d95a5-554c-49a4-b61a-1f509ddbd3a7",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">信息量少</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "9ca3a34d-a204-498e-8087-21a135f1a009",
        //           "quId": "981d95a5-554c-49a4-b61a-1f509ddbd3a7",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">对企业岗位专业知识缺乏了解</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "f623b123-5059-49f7-a3c5-119fedf44ffd",
        //           "quId": "981d95a5-554c-49a4-b61a-1f509ddbd3a7",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">自身能力不足</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "053367f0-ead9-484f-ae80-0dca4d064306",
        //           "quId": "981d95a5-554c-49a4-b61a-1f509ddbd3a7",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">对企业招聘流程和基本要求缺乏了解</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 4,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "e0b8da9e-8834-4f72-bafb-124e93670e35",
        //           "quId": "981d95a5-554c-49a4-b61a-1f509ddbd3a7",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">求职方法技巧欠缺</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 5,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "1fb1268c-7691-4b4f-83e7-e1aa04394d3b",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "981d95a5-554c-49a4-b61a-1f509ddbd3a7",
        //         "quItemId": "053367f0-ead9-484f-ae80-0dca4d064306",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "5dafac33-5de9-465f-a8b7-87c9972e6262",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">你实习时希望进入什么实习单位？</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 23,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "d4783749-ffe3-46d0-9c87-db48f0e0c11a",
        //           "quId": "5dafac33-5de9-465f-a8b7-87c9972e6262",
        //           "optionTitle": null,
        //           "optionName": "<span style=\"font-family: 仿宋_GB2312; font-size: 16pt;\">外企</span>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "61a4cd5b-ca68-4a52-83e3-097ee4cbdf38",
        //           "quId": "5dafac33-5de9-465f-a8b7-87c9972e6262",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">国企</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "f4ff3bed-de27-418a-bfb7-9a96a12b583f",
        //           "quId": "5dafac33-5de9-465f-a8b7-87c9972e6262",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">私企</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 2,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "41548b31-d07c-4567-b5dd-926bf5d10677",
        //           "quId": "5dafac33-5de9-465f-a8b7-87c9972e6262",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">机关单位</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 3,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "40e9ec0c-7940-46b2-87c7-1dfe8ac96d3e",
        //           "quId": "5dafac33-5de9-465f-a8b7-87c9972e6262",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">不在乎，重在获得经验</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 4,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "e441e732-443f-459b-9a47-56a3d8d43cfd",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "5dafac33-5de9-465f-a8b7-87c9972e6262",
        //         "quItemId": "61a4cd5b-ca68-4a52-83e3-097ee4cbdf38",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "5777a228-2b90-403f-bf2d-8ecfe3a238e0",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">你建议学校激励学生积极参与实习，提高实习质量，并通过表彰先进，树立典型，评选优秀实习生吗？</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "RADIO",
        //       "tag": 2,
        //       "orderById": 24,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": null,
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": null,
        //       "answerInputRow": null,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [
        //         {
        //           "id": "a8bd51dc-6304-4af7-b5da-77206a5dd5d0",
        //           "quId": "5777a228-2b90-403f-bf2d-8ecfe3a238e0",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">建议</span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 0,
        //           "visibility": 1,
        //           "anCount": 0
        //         },
        //         {
        //           "id": "7d4ef2ab-2b99-48b1-8491-a71c18492cc1",
        //           "quId": "5777a228-2b90-403f-bf2d-8ecfe3a238e0",
        //           "optionTitle": null,
        //           "optionName": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">不建议</span><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><o:p></o:p></span></p>",
        //           "isNote": 0,
        //           "checkType": "NO",
        //           "isRequiredFill": 0,
        //           "orderById": 1,
        //           "visibility": 1,
        //           "anCount": 0
        //         }
        //       ],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": "b197137f-aeb4-4f72-98e5-5f91650071bb",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "5777a228-2b90-403f-bf2d-8ecfe3a238e0",
        //         "quItemId": "a8bd51dc-6304-4af7-b5da-77206a5dd5d0",
        //         "otherText": "",
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "b12f29fe-fdf8-42d9-9c14-d9e3e1bfe323",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\">你最心仪的单位名称及心仪原因是什么？</span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "FILLBLANK",
        //       "tag": 2,
        //       "orderById": 25,
        //       "createDate": "2024-10-22 17:20:38",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": "NO",
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": 600,
        //       "answerInputRow": 3,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": "8541d04d-0ec2-4359-bee6-bb9717a54a29",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "b12f29fe-fdf8-42d9-9c14-d9e3e1bfe323",
        //         "answer": "无",
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "quItemId": null,
        //         "otherText": null,
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     },
        //     {
        //       "id": "29335f3b-743d-4be2-8ec1-0bf25770cd14",
        //       "userId": null,
        //       "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //       "quName": null,
        //       "quTitle": "<p class=\"MsoNormal\"><span style=\"mso-spacerun:'yes';font-family:仿宋_GB2312;font-size:16.0000pt;\nmso-font-kerning:1.0000pt;\"><font face=\"仿宋_GB2312\">你目前对实习还有什么问题</font><font face=\"仿宋_GB2312\">?</font></span></p>",
        //       "quNote": null,
        //       "keywords": null,
        //       "quType": "FILLBLANK",
        //       "tag": 2,
        //       "orderById": 26,
        //       "createDate": "2024-10-22 17:20:39",
        //       "quTag": 1,
        //       "parentQuId": null,
        //       "yesnoOption": null,
        //       "isRequired": 1,
        //       "checkType": "NO",
        //       "paramInt01": 0,
        //       "paramInt02": 0,
        //       "visibility": 1,
        //       "copyFromId": null,
        //       "hv": 2,
        //       "randOrder": 0,
        //       "cellCount": 0,
        //       "contactsAttr": 0,
        //       "contactsField": "0",
        //       "answerInputWidth": 600,
        //       "answerInputRow": 3,
        //       "startTime": null,
        //       "endTime": null,
        //       "depId": null,
        //       "majorId": null,
        //       "classId": null,
        //       "teacherId": null,
        //       "isWeek": null,
        //       "questions": [],
        //       "quRadios": [],
        //       "quCheckboxs": [],
        //       "quMultiFillblanks": [],
        //       "quScores": [],
        //       "quOrderbys": [],
        //       "rowContent": "",
        //       "colContent": "",
        //       "optionContent": "",
        //       "removeOptionUuIds": null,
        //       "anAnswer": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "answer": null,
        //         "visibility": 1
        //       },
        //       "anCheckboxs": [],
        //       "anDFillblanks": [],
        //       "anEnumqus": [],
        //       "anFillblank": {
        //         "id": "a307e2e0-c8cb-4444-b749-c0c53097ccfa",
        //         "belongId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //         "belongAnswerId": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //         "quId": "29335f3b-743d-4be2-8ec1-0bf25770cd14",
        //         "answer": "无",
        //         "visibility": 1
        //       },
        //       "anRadio": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "quItemId": null,
        //         "otherText": null,
        //         "visibility": 1
        //       },
        //       "anYesno": {
        //         "id": null,
        //         "belongId": null,
        //         "belongAnswerId": null,
        //         "quId": null,
        //         "yesnoAnswer": null,
        //         "visibility": 1
        //       },
        //       "anScores": [],
        //       "anCount": 0,
        //       "anOrders": [],
        //       "anUplodFiles": [],
        //       "questionLogics": [],
        //       "statJson": ""
        //     }
        //   ],
        //   "surveyAnswer": {
        //     "id": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106294942",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:52:26",
        //     "totalTime": 0,
        //     "ipAddr": "113.124.89.183",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "18264242005",
        //     "depName": "机电工程系",
        //     "depId": "54c7e5aec90583e447a6e0f58a3d898e",
        //     "majorId": "839346a8387f4c108978a5e76b52d495",
        //     "majorName": "机电设备维修与管理",
        //     "classId": "34ddabd18a237ec45155e859d692250d",
        //     "className": "23机电三二连读班",
        //     "userName": "孙启山",
        //     "studentNumber": "236377",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "cb24b45b8fa00d6b563df50df9e176aa",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   }
        // }
        this.survey = resultData
        for (let i = 0; i < this.survey.questions.length; i++) {
          const questionData = this.survey.questions[i]
          const quType = questionData.quType
          let quOptionsObj
          if (quType === 'CHECKBOX') {
            questionData.quTypeName = '多选题'
            quOptionsObj = questionData.quCheckboxs
          } else if (quType === 'RADIO') {
            questionData.quTypeName = '单选题'
            quOptionsObj = questionData.quRadios
          } else if (quType === 'FILLBLANK') {
            questionData.quTypeName = '填空题'
          } else if (quType === 'SCORE') {
            questionData.quTypeName = '评分题'
            quOptionsObj = questionData.quScores
          } else if (quType === 'ORDERQU') {
            questionData.quTypeName = '排序题'
            quOptionsObj = questionData.quOrderbys
          } else if (quType === 'MULTIFILLBLANK') {
            questionData.quTypeName = '多项填空题'
            quOptionsObj = questionData.quMultiFillblanks
          } else if (quType === 'UPLOADFILE') {
            questionData.quTypeName = '文件上传题'
          } else {
            questionData.quTypeName = quType
          }
          if (quType === 'CHECKBOX' || quType === 'SCORE' || quType === 'ORDERQU' || quType === 'MULTIFILLBLANK') {
            for (let j = 0; j < quOptionsObj.length; j++) {
              const item = quOptionsObj[j]
              if (quType === 'CHECKBOX') {
                const anCheckboxs = questionData.anCheckboxs
                for (let k = 0; k < anCheckboxs.length; k++) {
                  if (anCheckboxs[k].quItemId === item.id) {
                    item.answer = true
                    break
                  }
                }
              } else if (quType === 'SCORE') {
                const anScores = questionData.anScores
                for (let k = 0; k < anScores.length; k++) {
                  if (anScores[k].quRowId === item.id) {
                    if (anScores[k].answserScore != null) {
                      item.answer = parseInt(anScores[k].answserScore)
                      break
                    }
                  }
                }
              } else if (quType === 'ORDERQU') {
                const anOrders = questionData.anOrders
                for (let k = 0; k < anOrders.length; k++) {
                  if (anOrders[k].quRowId === item.id) {
                    item.answer = anOrders[k].orderyNum
                    break
                  }
                }
              } else if (quType === 'MULTIFILLBLANK') {
                const anDFillblanks = questionData.anDFillblanks
                for (let k = 0; k < anDFillblanks.length; k++) {
                  if (anDFillblanks[k].quItemId === item.id) {
                    item.answer = anDFillblanks[k].answer
                    break
                  }
                }
              }
            }
          }
        }
      })
    },
    handleCurrentChange: function (val) {

    }
  }
}

</script>
<style scoped>
.dw-page-header {
  padding: 20px;
  background-color: white;
}

.dw-answer-title {
  font-size: 16px;
  padding: 10px;
}

.dw-answer-content {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.dw-qu-item {
  margin-top: 10px;
}

.dw-qu-item-title {
  padding: 20px 0px;
  color: grey;
}

.dw-qu-item-body {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/dw-survey/dw-data/DwSurveyAnswerInfo.vue